/**
 * Static configuration for the consent layer.
 *
 * Everything the site is allowed to load after consent is declared here, so the
 * list of third parties is auditable in one place.
 */

/** Name of the first-party cookie holding the visitor's decision. */
export const CONSENT_COOKIE = 'cdgnm_consent';

/**
 * Bump when the choices or the set of third parties change. A stored decision
 * with an older version is treated as "not decided" so the visitor is asked again.
 * v2 replaced the purpose-based choices (statistics/marketing) with per-integration
 * ones, so every v1 decision has to be collected again.
 */
export const CONSENT_VERSION = 2;

/** Consent lifetime. 6 months is the retention the Austrian DSB expects. */
export const CONSENT_MAX_AGE_DAYS = 180;

/**
 * The integrations the visitor can decide on, in display order. These are the keys
 * of a decision and the suffix of their labels in the `cookies` locale namespace
 * (`googleAnalytics` -> `cookies.googleAnalytics` + `cookies.googleAnalyticsDescription`).
 *
 * Google Ads runs on the same Google tag as GA4 and is covered by the
 * `googleAnalytics` choice — there is no separate switch for it.
 */
export const PURPOSES = ['googleAnalytics', 'linkedinInsight'];

export const GA4_MEASUREMENT_ID = 'G-CL8QKFB5G6';
export const GOOGLE_ADS_ID = 'AW-591260464';
export const LINKEDIN_PARTNER_ID = '2731666';

export const GTAG_SRC = `https://www.googletagmanager.com/gtag/js?id=${GA4_MEASUREMENT_ID}`;
export const LINKEDIN_SRC = 'https://snap.licdn.com/li.lms-analytics/insight.min.js';

/**
 * Trackers only load when this is explicitly enabled at build time, so staging,
 * `gatsby develop` and the Playwright suite never send data to Google or LinkedIn.
 * Set via the ANALYTICS_ENABLED environment variable in the deploy workflow.
 */
export const ANALYTICS_ENABLED = process.env.GATSBY_ANALYTICS_ENABLED === 'true';

/**
 * First-party cookies written by the Google tag. These we can and must delete on
 * withdrawal. LinkedIn's cookies (bcookie, li_sugr, UserMatchHistory, ...) live on
 * .linkedin.com and cannot be removed from our JavaScript — see the privacy page.
 */
export const GOOGLE_COOKIE_PREFIXES = [
    '_ga',
    '_gid',
    '_gat',
    '_gcl_au',
    '_gcl_aw',
    '_gcl_dc',
    '_gac_',
];
